export default "__VITE_ASSET__DgbbngJi__"